import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import "flag-icon-css/css/flag-icons.min.css";

import Button from "shared/components/FormElements/Button";
import { languages } from "shared/util/types";
import { AuthContext } from "shared/context/auth-context";
import { isInternationalTheme } from "config/ConfigUtils";
import "./SettingsDropdown.css";

const SettingsDropdown = () => {
  const { t, i18n } = useTranslation();
  const auth = useContext(AuthContext);

  return (
    <Dropdown className="settings-dropdown" align="end">
      <Dropdown.Toggle variant="success" id="dropdown-settings" className="settings-dropdown-toggle">
        <FaUserCircle className="user-circle" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="settings-dropdown-menu">
        {(auth?.company?.name || auth?.name) && (
          <div className="settings-dropdown-user-info">
            <span className="settings-dropdown-user-name">{auth.name}</span>
            {auth?.company?.name && <span className="settings-dropdown-company-name">{auth?.company?.name}</span>}
          </div>
        )}

        {!isInternationalTheme() &&
          languages.map(({ code, name, country_code }) => (
            <Dropdown.Item
              eventKey={name}
              key={country_code}
              className="settings-dropdown-item"
              onClick={async () => {
                i18n.changeLanguage(code);
                localStorage.setItem("i18nextLng", code);
                auth.UpdateTheme(code);
              }}
            >
              <span className={`flag-icon flag-icon-${country_code}`}></span>
              {name}
            </Dropdown.Item>
          ))}

        {auth.isLoggedIn && (
          <div className="settings-dropdown-logout">
            <Button onClick={auth.logout}>{t("logout")}</Button>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SettingsDropdown;
